/// <amd-module name="Reporting/Lightbox/Lightbox" />
import React = require("react");
import { IVssPageContext } from "VSS/Platform/Context";
import { css, IVssComponentContext, IVssComponentProperties, IVssLayoutManager, VssComponent } from "VSS/Platform/Layout";
import { Dialog, IDialogProps } from "VSSUI/Dialog";

export interface LightboxProps extends IVssComponentProperties {
    title?: string;
    onDismiss: () => void;
    /** opt-in to request standard layout to be preserved */
    retainDefaultLayout?: boolean;
    className?: string;
}

export class Lightbox extends VssComponent<LightboxProps> {
    public constructor(props: LightboxProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        const dialogProps: IDialogProps = {
            onDismiss: this.props.onDismiss,
            calloutContentClassName: css("lightbox-content", this.props.className),
            className: css("lightbox-container", this.props.retainDefaultLayout ? null : "override-dialog-layout"),
            titleProps: { text: this.props.title || "" }
        };
        return <Dialog {...dialogProps}>{this.props.children}</Dialog>;
    }
}

VssComponent.register("Lightbox", Lightbox);

export function showActionRequiredDialog(pageContext: IVssPageContext, title: string, content: JSX.Element): void {
    const layoutManager = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
    layoutManager.renderCallout((onDismiss: () => void) => {
        return (
            <Lightbox onDismiss={onDismiss} title={title} retainDefaultLayout={true}>
                {content}
            </Lightbox>
        );
    });
}
